

export class OfferAcceptDecline{
    offerId:number = undefined
    acceptOrDecline:number = undefined
    vehicleId: number = undefined
    trailerId: number = undefined
    driverId:number = undefined
    reason:string = undefined
}